import ContactUs from "../components/ContactUs";
import AboutUs from "../components/AboutUs";
import HeroSection from '../components/HeroSection'
import InfoCards from '../components/InfoCards'

export default function Home() {
  return (
    <>
      <HeroSection />
      <InfoCards />
      <AboutUs />
      <ContactUs />
    </>
  );
}
